module.exports = __webpack_public_path__ + "static/media/membership01.7827380f.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/membership01.png
// module id = 2477
// module chunks = 0